import axios, {
  AxiosHeaders,
  type AxiosInstance,
  type InternalAxiosRequestConfig,
} from "axios";

import { getToken } from "./AuthToken";
import { getHeaderValues } from "./RequestHeaders";
import { normalizeError } from "./RequestError";

export const instance: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_BFF,
});

instance.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    const token = await getToken();
    const defaultHeaders = getHeaderValues();

    const headers = AxiosHeaders.from(config.headers);

    Object.entries(defaultHeaders).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        headers.set(key, value as string);
      }
    });

    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }

    config.headers = headers;

    return config;
  },
  (error: unknown) => Promise.reject(normalizeError(error))
);
